document.addEventListener('DOMContentLoaded', () => {
  const searchTrigger = document.querySelector('.header__search-bar');
  const searchDrawer = document.getElementById('search-drawer');

  if (searchTrigger && searchDrawer) {
    searchTrigger.addEventListener('click', () => {
      const isDesktop = window.matchMedia('(min-width: 768px)').matches;

      if (isDesktop) {
        searchDrawer.dispatchEvent(new CustomEvent('dialog:force-close'));
        searchDrawer.setAttribute('open', '');
      }
    });
  }
});